import "./Materials.module.css";
import Header from "@/reusable_sections/Header";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import MaterialCardGrid from "./sections/MaterialCardGrid";
import MaterialComparisonTable from "./sections/MaterialComparisonTable";
import SelectionGuidance from "./sections/SelectionGuidance";
import SpecSheetsColorChartsSamples from "./sections/SpecSheetsColorChartsSamples";
import FaqAccordion from "./sections/FaqAccordion";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function MaterialsPage() {
  return <div>
      <Header />
      <DirectAnswerBlock />
      <MaterialCardGrid />
      <MaterialComparisonTable />
      <SelectionGuidance />
      <SpecSheetsColorChartsSamples />
      <FaqAccordion />
      <ClosingCta />
      <Footer />
    </div>;
}